import styled from "styled-components";

import { Box, FlexDiv } from "@/components/Atoms/Box";
import Image from "@/components/Atoms/Image";

import Typography from "@/foundation/Typography/V2";

export const IconBox = styled(Box)`
  margin-right: 16px;
  &:last-child {
    margin-right: 0;
  }
`;
export const FooterPlayIcon = styled(Image)`
  max-width: 130px;
  border-radius: 6px;
  @media only screen and (max-width: 420px) {
    max-width: 120px;
  }
  @media only screen and (max-width: 390px) {
    max-width: 100px;
  }
`;
export const Wrapper = styled(FlexDiv)`
  align-items: center;
`;
export const DownloadCta = styled(Typography)`
  background-color: ${({ theme }) => theme.colorsV2.blue.shade_600};
  padding: 8px 16px;
  border-radius: 32px;
`;
export const DownloadText = styled(Typography)`
  color: ${({ theme }) => theme.colors.white};
`;
